import { DefaultDataServiceConfig } from '@ngrx/data';
import { environment } from '../../environments/environment';

export const dataServiceConfig: DefaultDataServiceConfig = {
    root: environment.apiUrl,
    timeout: 30000,
};
